import { useState, useRef, useEffect } from "react";
import { showToast } from "ui/components/common";
import { SvgWave } from "ui/svgs";

export default function NoteAudio({ url }) {
  const [playing, setIsPlaying] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const audioRef = useRef(null);

  const handlePlay = () => {
    try {
      if (playing) {
        audioRef.current.pause();
        setIsPlaying(false);
        audioRef.current.currentTime = 0;
      } else {
        audioRef.current
          .play()
          .then(() => {
            setIsPlaying(true);
          })
          .catch((error) => {
            console.error("Error occurred while playing audio:", error);
          });
      }
    } catch (error) {
      console.error("Error occurred while playing audio:", error);
      showToast(1, "Failed to operate audio. Please try again.");
    }
  };

  useEffect(() => {
    audioRef.current?.addEventListener("ended", () => {
      setIsPlaying(false);
    });
  }, []);

  if (!url) {
    return null;
  }

  return (
    <div>
      <button
        onClick={handlePlay}
        className="w-[52px] h-[44px] flex items-center justify-center rounded-2xl bg-[#DCE7FD] mt-2 hover:bg-[#e5eaff]"
      >
        {!isLoaded ? (
          <div
            className="ml-1 text-white  inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
            role="status"
          ></div>
        ) : playing ? (
          <img src="/wave.gif" width={20} />
        ) : (
          <SvgWave width="15" className="" />
        )}
      </button>
      <audio
        ref={audioRef}
        src={url}
        onError={(e) => {
          showToast(1, "Failed to load audio. Please try again.");
        }}
        onLoadedData={() => {
          setIsLoaded(true);
        }}
      />
    </div>
  );
}
